<div>
  <!-- Header / Nav -->
  <aux-trial-insights-nav />

  <!-- Route -->
  @if ((this.showClinOpsButton$ | async) === true || (this.showFinanceButton$ | async) === true) {
    <div>
      <router-outlet />
    </div>
  }
</div>
